import { useMemo } from 'react';

import OriginTracer from '@atlassiansox/origin-tracing';

import { type Product } from '../types';
import { useEditionAwareness } from './edition-awareness-context';

export const PRODUCT_TO_ORIGIN: Record<Product, string> = {
	['confluence']: 'confluence',
	['jira']: 'jira',
	['jira-product-discovery']: 'jira',
	['jira-service-management']: 'jira',
	['jira-customer-service']: 'jira',
};

/**
 * Generic function to use a traced URL to ensure that we have the correct origin added to it
 */
export function useTracedUrl(untracedUrl?: string | null): {
	origin: OriginTracer;
	url: string | undefined;
} {
	const { product } = useEditionAwareness();

	const origin = useMemo(
		() => new OriginTracer({ product: PRODUCT_TO_ORIGIN[product] }),
		[product],
	);

	const url = useMemo(
		() => (untracedUrl ? origin.addToUrl(untracedUrl) : undefined),
		[untracedUrl, origin],
	);

	return {
		url,
		origin,
	};
}
